import { z } from "zod";

const fieldSpecSchema = z.object({
  fieldSpecId: z.number(),
  textValue: z.string().nullish(),
  numericValue: z.coerce.number().nullish(),
  dateValue: z.string().nullish(),
  booleanValue: z.boolean().nullish(),
  optionId: z.number().nullish(),
});

const baseSchema = z.object({
  tubeId: z.number(),
  collection: z.string().nullish(),
  refrigerated: z.string().nullish(),
  centrifuged: z.string().nullish(),
  collectionTimezone: z.string().nullish(),
  refrigeratedTimezone: z.string().nullish(),
  centrifugedTimezone: z.string().nullish(),
  quantity: z.number().optional(),
  lot: z.string().nullish(),
  expiration: z.date().nullish(),
  typeId: z.string().nullish(),
  transfusionId: z.string().nullish(),
  fields: z.array(fieldSpecSchema).prefault([]),
});

export const createSampleSchema = baseSchema.extend({
  accessionId: z.number(),
});

export const updateSampleSchema = baseSchema.omit({ fields: true }).extend({
  id: z.number(),
  accessionId: z.number(),
  fields: z
    .array(fieldSpecSchema.extend({ id: z.number().optional() }))
    .prefault([]),
  temp: z.coerce.number().nullish(),
  tempType: z.enum(["ambient", "refrigerated", "frozen"]).nullish(),
  tempUnits: z.enum(["C", "F"]).nullish(),
});

const sampleTempEntrySchema = z
  .object({
    id: z.number(),
    temp: z.coerce.number().nullish(),
    tempType: z.enum(["ambient", "refrigerated", "frozen"]).nullish(),
    tempUnits: z.enum(["C", "F"]).nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.temp == null && val.tempType == null) {
      ctx.addIssue({
        code: "custom",
        message: "Numeric temperature or temperature type is required",
      });
    }
    if (val.temp != null && val.tempUnits == null) {
      ctx.addIssue({
        code: "custom",
        message: "Units are required if a temperature value is provided",
        path: ["tempUnits"],
      });
    }
  });

export const sampleTempsInputSchema = z
  .array(sampleTempEntrySchema)
  .min(1, "At least one sample is required");
